import { Navigate } from 'react-router-dom';
import { useClientAuth } from './ClientAuthContext';

export default function ClientPrivateRoute({ children }) {
  const { clientAuth, isHydrated } = useClientAuth();

  if (!isHydrated) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  if (!clientAuth?.clientId) {
    return <Navigate to="/client/login" replace />;
  }

  return children;
}
